export enum SearchType {
  dashboard = 'dashboard',
  dashboardExplore = 'dashboardExplore',
  channel = 'channel',
  getgot = 'getgot',
  profile = 'profile',
}
